(function config(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewerOpener) {
    return;
  }

  const previousConfig = global.NewHomeSource.FullImageViewer.Config;
  const defaultThumbnails = JSON.parse(document.querySelector('[data-component="defaultThumbnails"]').innerHTML);
  const languageResources = JSON.parse(document.querySelector('[data-component="languageResources"]').innerHTML);
  const querySwiperElement = '[data-full-image-viewer-role="swiper-container"]';
  const isTouchScreen = Object.prototype.hasOwnProperty.call(global, 'ontouchstart');
  const zoomableCollections = ['floorplan', 'map'];
  const notDisplayWithinSandboxExtensions = /(?:pdf)/;
  const isMediaGoingToBeShownInCarousel = global.document.querySelector(querySwiperElement);

  /**
   * @private
   * processImage: adds the relevat image information into the fullImageViewerData collection.
   *
   * @param {string} collectionName name of the image collection.
   * @param {object} image with the information relevat of the element.
   * @param {int} index image index.
   */
  function processImage(collectionName) {
    const imageElement = { };
    const length = this.length;
    const links = [];

    for (let index = 0; index < length; index += 1) {
      const element = this[index];
      const media = {
        title: element.Title,
        url: element.Url,
        type: element.Type,
        id: element.Id,
      };

      links.push(media);
    }

    imageElement.Collection = collectionName;
    imageElement.Id = this[0].Id;
    imageElement.IsCtaSlide = false;
    imageElement.IsSelected = false;
    imageElement.OpenExternally = false;
    imageElement.Source = defaultThumbnails[collectionName.toLowerCase()];
    imageElement.links = links;

    return imageElement;
  }

  /**
  * @constructs NewHomeSource.FullImageViewer.Config
  */
  function Config() {
  }

  const specialCollections = {
    other: {
      isCaptionBarVisible: false,
      isFilmStripVisible: false,
      processImage,
    },
  };

  /**
  * @public
  * getClickOrTouchEvent: returns 'click' if the device doesn't supports touch events, 'touchend' otherwise.
  */
  Config.getClickOrTouchEvent = function getClickOrTouchEvent() {
    return isTouchScreen ? 'touchend' : 'click';
  };

  /**
  * @public
  * isMobileDevice: returns 'click' if the device doesn't supports touch events, 'touchend' otherwise.
  */
  Config.isMobileDevice = function isMobileDevice() {
    return !!document.querySelector('[data-ismobiledevice="true"]');
  };

  /**
  * @public
  * isCaptionBarVisible: returns true if a collection should display the caption bar, otherwise false.
  *
  * @param {object} data with the information of the object being evaluated.
  */
  Config.isCaptionBarVisible = function isCaptionBarVisible(data) {
    if (!data) {
      return true;
    }

    const collectionConfig = specialCollections[data.Collection.toLowerCase()];

    if (typeof collectionConfig === 'object' &&
      Object.prototype.hasOwnProperty.call(collectionConfig, 'isCaptionBarVisible')) {
      return collectionConfig.isCaptionBarVisible;
    }

    return true;
  };

  /**
  * @public
  * isFilmStripVisible: returns true if a collection should display the filmstrip, otherwise false.
  *
  * @param {object} data with the information of the object being evaluated.
  */
  Config.isFilmStripVisible = function isFilmStripVisible(data) {
    if (!data) {
      return false;
    }

    const collectionConfig = specialCollections[data.Name.toLowerCase()];

    if (typeof collectionConfig === 'object' &&
      Object.prototype.hasOwnProperty.call(collectionConfig, 'isFilmStripVisible')) {
      return collectionConfig.isFilmStripVisible;
    }

    const collectionImages = data.Images;
    const imageKeys = Object.keys(collectionImages);
    return imageKeys.length > 1;
  };

  /**
  * @public
  * isZoomableCollection: returns true if a collection should be handled by the Zoom module, otherwise false.
  *
  * @param {object} data with the information of the object being evaluated.
  */
  Config.isZoomableCollection = function isZoomableCollection(data) {
    const collectionName = data.Collection || data.Name;
    return zoomableCollections.includes(collectionName.toLowerCase()) && !data.IsFrame;
  };

  /**
  * @public
  * isDisplayInSandBoxCollection: returns true if a collection should have sandbox attribute, otherwise false.
  *
  * @param {object} data with the information of the object being evaluated.
  */
  Config.isDisplayInSandBoxCollection = function isDisplayInSandBoxCollection(data) {
    return data.Source.match(notDisplayWithinSandboxExtensions) == null;
  };

  /**
   * @public
   * getAttributeValue: get value of data attribute on FIV
   *
   * @param {String} attribute to be selected.
   */
  Config.getAttributeValue = function getAttributeValue(attribute) {
    const element = Config.fullImageViewer.querySelector('[' + attribute + ']');
    return element && element.getAttribute(attribute);
  };

  Config.filmStrip = global.document.querySelector('[data-full-image-viewer-role="filmstrip-parent"]');
  Config.fullImageViewer = global.document.querySelector('[data-component="full-image-viewer"]');
  Config.scheduleATour = global.document.querySelector('[data-component="full-image-viewer-schedule-tour-cta"]');
  Config.otherMedia = global.document.querySelector('[data-full-image-viewer-role="other-media"]');
  Config.defaultThumbs = defaultThumbnails;
  Config.collectionConfig = specialCollections;
  Config.languageResources = languageResources;
  Config.isMediShownInCarousel = isMediaGoingToBeShownInCarousel;
  Config.queryImagesContainer = isMediaGoingToBeShownInCarousel
    ? '[data-full-image-viewer-role="viewer"]'
    : '[data-full-image-viewer-role="main-media-container"]';
  Config.dataTdvAttributes = ['data-builder', 'data-community', 'data-parent-community-id', 'data-market',
    'data-plan-id', 'data-spec-id'];

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.FullImageViewer.Config to the previous script.
  */
  Config.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.Config = previousConfig;
    return Config;
  };

  global.NewHomeSource.FullImageViewer.Config = Config;
}(window));
